import script from "./UiToast.vue?vue&type=script&setup=true&lang=js"
export * from "./UiToast.vue?vue&type=script&setup=true&lang=js"

import "./UiToast.vue?vue&type=style&index=0&id=1cfbbc2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cfbbc2a"]])

export default __exports__